import { useSelector } from 'react-redux'

// import { setDynamicModalObj, updateGroups } from '../store/board.actions'
import { updateGrupoAction,setDynamicModalObj2 } from "../store/grupo.actions";
import { utilService } from '../services/util.service'

import { BsFillCircleFill } from 'react-icons/bs'

export function ColorPalette({ dynamicModalObj }) {
    const colors = utilService.getColors() //funcionaa
    const board = useSelector(storeState => storeState.boardModule.filteredBoard) 

    
    function onChangeGroupColor(color) {
        try {
            dynamicModalObj.group.color = color

           // Extraer los valores del grupo que se quieren actualizar
        const updatedGroup = {
            id_grupo: dynamicModalObj.group.id_grupo,
            nombre_grupo: dynamicModalObj.group.nombre_grupo, // Suponiendo que se está editando el nombre del grupo
            estado: dynamicModalObj.group.estado,
            fk_tableros_id: dynamicModalObj.group.fk_tableros_id,
            color: dynamicModalObj.group.color
        };
    
        try {
            updateGrupoAction(dynamicModalObj.group.id_grupo,updatedGroup);

            dynamicModalObj.type = 'menu-group';
            setDynamicModalObj2({ ...dynamicModalObj });

          
            
        } catch (err) {
            console.log('Failed to Update');
        }

           
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <div className='color-palette'>
            {colors.map((color, idx) => (
                <BsFillCircleFill className='color-icon' onClick={() => onChangeGroupColor(color)}
                    key={idx} style={{ color: color }} />
            ))}
        </div>
    )
}

